import React, { useState } from "react";
import styled from "styled-components";
import Modal from "../Kanban/Modal/Modal";
import { useSession } from "../../authentications/SessionContext";
import { onChangeProductSocialMediaPost } from "../../DataApi/products/onChangeProductSocialMediaPost";
import { create } from "../../DataApi/create";
import { callButtonProductSocialMediaPost } from "../../DataApi/products/callButtonProductSocialMediaPost";
import { onChange } from "../../DataApi/onchange";
import { callButton } from "../../DataApi/products/callButtonOpenSocialMediaWizard";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { handleResponse } from "../../utilities/handleResponse";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { primaryColor } from "../../utilities/colors";


const LOADING_OPTIONS = ["product.template", "active.social.media"];
const ActionButton = styled.button`
  border-radius: 10px;
  background-color: #ff5837;
  color: #ffffff;
  family-font: "Inter";
  border: none;
  // width: 80px;
  min-width: 90px;
  height: 35px;
  margin-right: 20px;
`;
const TableContainer = styled.div`
  margin: 20px !important;
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr {
    padding: 21px !important;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
    font-weight: 600;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 15px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
    font-size: 17px;
  }

  tbody tr:hover {
    background-color: #f4f8ff;
  }
`;
function PublishSocialMedia({
  isModalOpen,
  setIsModalOpen,
  productId,
  isPublishedOnWebsite,
}) {
  const { sessionInfo } = useSession();
  const { company_id, context , social_media_active} = sessionInfo;

  const { language, translations } = useLanguage();
  const t = translations[language];

  const [socialMediaPost, setSocialMediaPost] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [socialMediaDetail, setSocialMediaDetail] = useState([]);
  const [postResult, setPostResult] = useState([]);
  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const openResponseModal = () => {
    setIsResponseModalOpen(true);
  };

  const closeResponseModal = () => {
    setIsResponseModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const fetchData = async ({ method, payload }) => {
    const fetchObject = {
      create,
      read: callButtonProductSocialMediaPost,
    };
    const fetchMethod = fetchObject[method];
    if (!fetchMethod) return "";
    let response = await fetchMethod(payload);
    response = JSON.parse(response);
    return response;
  };
  const handleSocialMediaPost = async () => {
    if (!socialMediaPost) return;
    setIsLoading(LOADING_OPTIONS[1]);
    const payload = {
      custom_merchant_post_message: socialMediaPost,
      lines: socialMediaDetail,
    };
    let createPost = await fetchData({
      method: "create",
      payload: {
        company_id,
        context,
        model: "active.social.media",
        payload,
      },
    });
    if (createPost.result) {
      const postResponse = await fetchData({
        method: "read",
        payload: {
          context,
          company_id,
          post_id: createPost.result,
          product_id: productId,
          model: "active.social.media",
          default_lines: socialMediaDetail.map((social) => ({
            ...social[2],
            page_id: false,
          })),
        },
      });
      if (postResponse) {
        const default_resp_lines = {
          lines: "",
          "lines.display_name": "",
          "lines.social_media_id": "",
          "lines.status": "",
          "lines.status_message": "",
        };
        const changeModel = "ayrshare.response";
        const raw = JSON.stringify({
          jsonrpc: "2.0",
          method: "call",
          params: {
            args: [[], {}, [], default_resp_lines],
            kwargs: {
              context: {
                active_id: createPost.result,
                active_ids: [createPost.result],
                active_model: "active.social.media",
                allowed_company_ids: [company_id],
                default_lines: postResponse?.result?.context?.default_lines,
                lang: context.lang,
                params: {
                  cids: company_id,
                  model: "product.template",
                  view_type: "list",
                },
                parent_obj_id: productId,
                tz: context.tz,
                uid: context.uid,
              },
            },
            method: "onchange",
            model: changeModel,
          },
        });
        let onChangeAfterPostResp = await onChange(raw, changeModel);
        onChangeAfterPostResp = JSON.parse(onChangeAfterPostResp);

        closeModal();
        const lines = onChangeAfterPostResp?.result.value.lines;
        const filteredPostResult = [];

        lines.forEach((line) => {
          line.forEach((item) => {
            if (item && typeof item === "object" && "status" in item) {
              filteredPostResult.push(item);
            }
          });
        });

        setPostResult(filteredPostResult);
        openResponseModal();
      }
    }
    setIsLoading(false);
  };
  const handleToggleSocialMedia = (e, index) => {
    socialMediaDetail[index][2].selected = e.target.checked;
    setSocialMediaDetail([...socialMediaDetail]);
  };
  const openSocialMediaWizard = async () => {
    setIsLoading(LOADING_OPTIONS[0]);
    let callBtnRes = await callButton({
      context,
      company_id,
      model: "product.template",
      productId,
    });
    callBtnRes = JSON.parse(callBtnRes);
    if (callBtnRes?.result?.context?.default_lines) {
      const response = await onChangeProductSocialMediaPost({
        context,
        company_id,
        defaultLines: callBtnRes?.result?.context?.default_lines || [],
      });
      if (response?.result?.value?.lines?.length > 1) {
        const lines = [...response?.result?.value?.lines];
        lines?.splice(0, 1);
        const updatedLinse = lines.map((lines) => [
          lines[0],
          `virtual_${parseInt(Math.random() * 1000)}`,
          lines[2],
        ]);
        setSocialMediaDetail(updatedLinse);
        openModal();
      }
    } else {
      toggleModal();
      handleResponse({
        response: callBtnRes,
        setMetaData,
        setTitle,
        successMessage: "",
      });
    }
    setIsLoading(false);
  };

  return (
    <div>
      <ConfirmationModal />
      {social_media_active && (
        <button
          disabled={!isPublishedOnWebsite || isLoading}
          title={
            !isPublishedOnWebsite
              ? "Publish the product on the website to enable sharing on social media."
              : "Publish on social media."
          }
          type="button"
          onClick={openSocialMediaWizard}
          style={{
            color: primaryColor.primary,
            border: "none",
            marginTop: "10px",
            backgroundColor: "transparent",
            fontWeight: "500",
          }}
        >
          <i className="bi bi-share-fill"></i>
          <span className="me-2">
            {isLoading === LOADING_OPTIONS[0]
              ? "Loading..."
              : t["Publish on Social Media"]}
          </span>
        </button>
      )}
      <Modal isOpen={isResponseModalOpen} onClose={closeResponseModal}>
        <div className="modal-header">
          <h5 className="modal-title">{t["Post social media result"]}</h5>
          <button
            type="button"
            className="ms-2 btn-close"
            onClick={closeResponseModal}
          ></button>
        </div>
        <div className="modal-body">
          <div className="d-flex gap-4">
            <div className="w-100">
              <TableContainer>
                <table className="table">
                  <thead>
                    <tr className="heading_row">
                      <th>{t["Social Media"]}</th>
                      <th>{t["Post Status"]}</th>
                      <th>{t["Message"]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {postResult?.map((line, index) => (
                      <tr key={index}>
                        <td>{line?.display_name}</td>
                        <td>{line?.status}</td>
                        <td>{line?.status_message}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </TableContainer>
            </div>
          </div>
        </div>
        <div className="modal-footer d-flex justify-content-end">
          <ActionButton
            type="button"
            role="button"
            onClick={closeResponseModal}
          >
            {t["Ok"]}
          </ActionButton>
        </div>
      </Modal>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="modal-header">
          <h5 className="modal-title">{t["Select Social Media"]}</h5>
          <button
            type="button"
            className="ms-2 btn-close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body">
          <div className="d-flex gap-4">
            <div className="w-100">
              <div className="mb-3">
                <label className="form-label">{t["Custom Post Message"]}</label>
                <div>
                  <textarea
                    value={socialMediaPost}
                    onChange={(e) => setSocialMediaPost(e.target.value)}
                    style={{
                      width: "900px",
                      border: "1px solid #CBCBCB",
                      // margin: "10px 15px 15px",
                      padding: "10px",
                      borderRadius: "15px",
                      color: "#535559",
                      height: "100px",
                      backgroundColor: "#f5f5f5",
                    }}
                  />
                </div>
              </div>

              <TableContainer>
                <table className="table">
                  <thead>
                    <tr className="heading_row">
                      <th>{t["Active"]}</th>
                      <th>{t["Social Media"]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {socialMediaDetail?.map((social, index) => (
                      <tr key={social?.[2].ayrshare_id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={social?.[2]?.selected}
                            onChange={(e) => {
                              handleToggleSocialMedia(e, index);
                            }}
                          />
                        </td>
                        <td>{social?.[2]?.display_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </TableContainer>
            </div>
          </div>
        </div>
        <div className="modal-footer d-flex justify-content-end">
          <ActionButton
            type="button"
            role="button"
            onClick={handleSocialMediaPost}
            disabled={isLoading}
          >
            {isLoading === LOADING_OPTIONS[1] ? "Publishing..." : "publish"}
          </ActionButton>
          <ActionButton
            type="button"
            role="button"
            disabled={isLoading}
            onClick={closeModal}
          >
            {t["Cancel"]}
          </ActionButton>
        </div>
      </Modal>
    </div>
  );
}

export default PublishSocialMedia;
